import { Component } from '@angular/core';

@Component({
  selector: 'mav-scatter-graph-icon',
  templateUrl: './scatter-graph-icon.component.html',
  styleUrls: ['./scatter-graph-icon.component.scss']
})
export class ScatterGraphIconComponent {

  constructor() { }
}
